import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=43698768&scoped=true"
import script from "./newsInfo.vue?vue&type=script&lang=js"
export * from "./newsInfo.vue?vue&type=script&lang=js"
import style0 from "./newsInfo.vue?vue&type=style&index=0&id=43698768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43698768",
  null
  
)

export default component.exports